module.exports = __webpack_public_path__ + "static/aurimas-profile-face-4ccbc212ef9648205e549f081e9d2bb7.jpg";